import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";

class DefaultPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <NavLink
          to={
            "/timetracking/" +
            this.props.match.params.ssoid +
            "/technician/monthview"
          }
        >
          <Trans>technicianCalendarView</Trans>
        </NavLink>
        <NavLink
          to={
            "/timetracking/" +
            this.props.match.params.ssoid +
            "/technician/addcallout"
          }
        >
          <Trans>technicianAddCallout</Trans>
        </NavLink>
        <NavLink
          to={
            "/timetracking/" +
            this.props.match.params.ssoid +
            "/technician/callouts"
          }
        >
          <Trans>technicianCallout</Trans>
        </NavLink>
        <NavLink
          to={
            "/timetracking/" +
            this.props.match.params.ssoid +
            "/technician/hoursadjustment&payment"
          }
        >
          <Trans>technicianPayment</Trans>
        </NavLink>
      </>
    );
  }
}

export default withTranslation()(DefaultPage);
